<vnm-feature-gate feature="verifiable_credentials">
  <ng-template #gated>
    <div
      class="attention-boundary-multi-use"
      [ngClass]="{
        'medium-appearance': drawAttention
      }"
    >
      <h3 *ngIf="showHeader" [innerText]="certification.verifiedCredentialIssuer.preambleButtonLabel"></h3>
      <!-- Mine || someone I manage -->
      <div *ngIf="certification.can.shareToSocial; else adminView">
        <div *ngIf="!verifiedCredential; else recordExists">
          <span *ngIf="showMessage" [innerHTML]="certification.verifiedCredentialIssuer.preambleHtml"></span>
          <vnm-dialog-toggle
            [label]="certification.verifiedCredentialIssuer.preambleButtonLabel"
            [header]="certification.verifiedCredentialIssuer.preambleButtonLabel"
            icon="fa fa-fw fa-qrcode"
            [buttonNgClass]="{
              'w-full sparkle-border': true,
              'mt-3': showMessage
            }"
            [eventType]="eventType"
          >
            <ng-template #toggle>
              <vnm-verifiable-credential-wizard [certification]="certification"></vnm-verifiable-credential-wizard>
            </ng-template>
          </vnm-dialog-toggle>
        </div>
        <ng-template #recordExists>
          <vnm-dialog-toggle
            [label]="certification.verifiedCredentialIssuer.preambleButtonLabel"
            [header]="certification.verifiedCredentialIssuer.preambleButtonLabel"
            icon="fa fa-fw fa-qrcode"
            buttonNgClass="w-full medium-appearance link-document-button"
            [eventType]="eventType"
          >
            <ng-template #toggle>
              <vnm-verifiable-credential-wizard [certification]="certification"></vnm-verifiable-credential-wizard>
            </ng-template>
          </vnm-dialog-toggle>
        </ng-template>
      </div>
    </div>
    <ng-template #adminView>
      <fa-icon
        class="icon"
        [ngClass]="verifiedCredential ? 'found' : 'not-found'"
        [icon]="['fas', verifiedCredential ? 'check' : 'times']"
      ></fa-icon>
      <span [innerHTML]="walletStatus | translate"></span>
    </ng-template>
  </ng-template>
</vnm-feature-gate>
